const ForYouTabMobileIcon = () => (
	<svg
		width={48}
		height={48}
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M24 45C35.598 45 45 35.598 45 24C45 12.402 35.598 3 24 3C12.402 3 3 12.402 3 24C3 35.598 12.402 45 24 45Z"
			fill="#EBF3FE"
		/>
		<rect
			x={15.44}
			y={15.44}
			width={7.12}
			height={7.12}
			rx={1.56}
			fill="url(#paint0_linear_20485_87077)"
			stroke="#190A28"
			strokeWidth={0.88}
		/>
		<rect
			x={25.44}
			y={15.44}
			width={7.12}
			height={7.12}
			rx={1.56}
			fill="url(#paint1_linear_20485_87077)"
			stroke="#190A28"
			strokeWidth={0.88}
		/>
		<rect
			x={15.44}
			y={25.44}
			width={7.12}
			height={7.12}
			rx={1.56}
			fill="url(#paint2_linear_20485_87077)"
			stroke="#190A28"
			strokeWidth={0.88}
		/>
		<rect
			x={25.44}
			y={25.44}
			width={7.12}
			height={7.12}
			rx={1.56}
			fill="url(#paint3_linear_20485_87077)"
			stroke="#190A28"
			strokeWidth={0.88}
		/>
		<defs>
			<linearGradient
				id="paint0_linear_20485_87077"
				x1={12.4159}
				y1={17.5841}
				x2={17.5841}
				y2={25.5841}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_20485_87077"
				x1={22.4159}
				y1={17.5841}
				x2={27.5841}
				y2={25.5841}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_20485_87077"
				x1={12.4159}
				y1={27.5841}
				x2={17.5841}
				y2={35.5841}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_20485_87077"
				x1={22.4159}
				y1={27.5841}
				x2={27.5841}
				y2={35.5841}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
		</defs>
	</svg>
);
const ForYouTabSelectedMobileIcon = () => (
	<svg
		width={48}
		height={48}
		viewBox="0 0 48 48"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M44.5 24C44.5 35.3218 35.3218 44.5 24 44.5C12.6782 44.5 3.5 35.3218 3.5 24C3.5 12.6782 12.6782 3.5 24 3.5C35.3218 3.5 44.5 12.6782 44.5 24Z"
			fill="#EBF3FE"
			stroke="#0074E8"
		/>
		<rect
			x={15.44}
			y={15.44}
			width={7.12}
			height={7.12}
			rx={1.56}
			fill="url(#paint0_linear_20485_86828)"
			stroke="#190A28"
			strokeWidth={0.88}
		/>
		<rect
			x={25.44}
			y={15.44}
			width={7.12}
			height={7.12}
			rx={1.56}
			fill="url(#paint1_linear_20485_86828)"
			stroke="#190A28"
			strokeWidth={0.88}
		/>
		<rect
			x={15.44}
			y={25.44}
			width={7.12}
			height={7.12}
			rx={1.56}
			fill="url(#paint2_linear_20485_86828)"
			stroke="#190A28"
			strokeWidth={0.88}
		/>
		<rect
			x={25.44}
			y={25.44}
			width={7.12}
			height={7.12}
			rx={1.56}
			fill="url(#paint3_linear_20485_86828)"
			stroke="#190A28"
			strokeWidth={0.88}
		/>
		<defs>
			<linearGradient
				id="paint0_linear_20485_86828"
				x1={12.4159}
				y1={17.5841}
				x2={17.5841}
				y2={25.5841}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_20485_86828"
				x1={22.4159}
				y1={17.5841}
				x2={27.5841}
				y2={25.5841}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_20485_86828"
				x1={12.4159}
				y1={27.5841}
				x2={17.5841}
				y2={35.5841}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_20485_86828"
				x1={22.4159}
				y1={27.5841}
				x2={27.5841}
				y2={35.5841}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
		</defs>
	</svg>
);

const ForYouTabDesktopIcon = () => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_20351_814556)">
			<path
				d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
				fill="white"
			/>
			<rect
				x={12.0108}
				y={12.0103}
				width={6.64533}
				height={6.64533}
				rx={1.456}
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.821333}
			/>
			<rect
				x={21.344}
				y={12.0103}
				width={6.64533}
				height={6.64533}
				rx={1.456}
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.821333}
			/>
			<rect
				x={12.0108}
				y={21.3443}
				width={6.64533}
				height={6.64533}
				rx={1.456}
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.821333}
			/>
			<rect
				x={21.344}
				y={21.3443}
				width={6.64533}
				height={6.64533}
				rx={1.456}
				fill="#E8E7EA"
				stroke="#190A28"
				strokeWidth={0.821333}
			/>
		</g>
		<defs>
			<clipPath id="clip0_20351_814556">
				<rect width={40} height={40} fill="white" />
			</clipPath>
		</defs>
	</svg>
);
const ForYouTabSelectedDesktopIcon = () => (
	<svg
		width={40}
		height={40}
		viewBox="0 0 40 40"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_20351_814453)">
			<path
				d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
				fill="#C1DBFB"
			/>
			<rect
				x={12.0108}
				y={12.0103}
				width={6.64533}
				height={6.64533}
				rx={1.456}
				fill="url(#paint0_linear_20351_814453)"
				stroke="#190A28"
				strokeWidth={0.821333}
			/>
			<rect
				x={21.344}
				y={12.0103}
				width={6.64533}
				height={6.64533}
				rx={1.456}
				fill="url(#paint1_linear_20351_814453)"
				stroke="#190A28"
				strokeWidth={0.821333}
			/>
			<rect
				x={12.0106}
				y={21.3443}
				width={6.64533}
				height={6.64533}
				rx={1.456}
				fill="url(#paint2_linear_20351_814453)"
				stroke="#190A28"
				strokeWidth={0.821333}
			/>
			<rect
				x={21.3439}
				y={21.3443}
				width={6.64533}
				height={6.64533}
				rx={1.456}
				fill="url(#paint3_linear_20351_814453)"
				stroke="#190A28"
				strokeWidth={0.821333}
			/>
		</g>
		<defs>
			<linearGradient
				id="paint0_linear_20351_814453"
				x1={9.1883}
				y1={14.0114}
				x2={14.0119}
				y2={21.4781}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_20351_814453"
				x1={18.5216}
				y1={14.0114}
				x2={23.3451}
				y2={21.4781}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_20351_814453"
				x1={9.18818}
				y1={23.3454}
				x2={14.0118}
				y2={30.8121}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_20351_814453"
				x1={18.5214}
				y1={23.3454}
				x2={23.345}
				y2={30.8121}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#5B8DEF" />
				<stop offset={1} stopColor="#0063F7" />
			</linearGradient>
			<clipPath id="clip0_20351_814453">
				<rect width={40} height={40} fill="white" />
			</clipPath>
		</defs>
	</svg>
);

const ForYouTabIcon = {
	mobile: <ForYouTabMobileIcon />,
	mobileSelected: <ForYouTabSelectedMobileIcon />,
	desktop: <ForYouTabDesktopIcon />,
	desktopSelected: <ForYouTabSelectedDesktopIcon />,
};

export default ForYouTabIcon;
